import request from 'utils/request'

/**
 * 登录接口
 * @param data
 * @returns {*}
 */
export const routerAdfs = data => {
  return request().get('/adfs/login', data)
}
export const getMenu = data => {
  return request().get('/adfs/query/menu', data)
}
export const login = data => {
  return request().post('login', data)
}

// 查询系统名称
export const queryTitle = stamp => request().get(`title?_=${stamp}`)

// 重置密码-获取验证码
export const getCaptcha = data =>
  request().post('userpassword/forget/email', data)

// 重置密码
export const submitModify = data =>
  request().post('userpassword/forget/modify', data)
